// src/pages/NotFoundPage/NotFoundPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faSearch, faMapSigns, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import Navbar from '../../components/common/Navbar/Navbar';
import Footer from '../../components/common/Footer/Footer';
import Button from '../../components/common/Button/Button';
import './NotFoundPage.css';

const NotFoundPage = () => {
    return (
        <div className="not-found-page">
            <Navbar />

            <main>
                <div className="container">
                    <div className="not-found-content">
                        <div className="not-found-graphic">
                            <div className="error-code">404</div>
                            <FontAwesomeIcon icon={faMapSigns} className="error-icon" />
                        </div>

                        <div className="not-found-text">
                            <h1>Page Not Found</h1>
                            <p>
                                Oops! The page you're looking for doesn't exist or has been moved.
                            </p>

                            <div className="suggestion-box">
                                <h2>
                                    <FontAwesomeIcon icon={faSearch} />
                                    Suggestions
                                </h2>
                                <ul>
                                    <li>Check if the URL was typed correctly</li>
                                    <li>Return to the homepage</li>
                                    <li>Visit our school pages</li>
                                    <li>Check out our summer camp</li>
                                    <li>Contact us for assistance</li>
                                </ul>
                            </div>

                            <div className="not-found-cta">
                                <Button
                                    variant="primary"
                                    to="/"
                                    icon={<FontAwesomeIcon icon={faHome} />}
                                    iconPosition="left"
                                >
                                    Back to Home
                                </Button>

                                <Button
                                    variant="outline"
                                    to="/contact"
                                    icon={<FontAwesomeIcon icon={faEnvelope} />}
                                    iconPosition="left"
                                >
                                    Contact Us
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default NotFoundPage;